import React from "react";
import { Select } from "antd";

const Option = Select.Option;

export default class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  state = {
    size: "default"
  };
  

  handleChange(value) {
    this.props.designatedHandler(value);
  }

  render() {
    const { size } = this.state;
    
    const placeholder = 
      <div className="">
        Type medication here
      </div>

    return (
      <Select
        mode="multiple"
        size={size}
        placeholder={placeholder}
        value={this.props.checkedKeys}
        onChange={this.handleChange}
      >
        {this.props.filterOptions.map(key => (
          <Option key={key}>{key}</Option>
        ))}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/SelectDialog/SearchBar.js